import { Media } from "./media";

export interface AthleteTeam {
    id: number;
    name: string;
    club_id: number;
    club_name: string;
}

export interface AthleteTeamSeason {
    id: number;
    athlete_id: number;
    athlete_name: string;
    team_id: number;
    team_name: string;
    season_id: number;
    season_name: string;
    club_id: number;
    club_name: string;
    dorsal: string;
    position: string;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
    current: boolean;
}

export const emptyAthleteTeamSeason: AthleteTeamSeason = {
    id: 0,
    athlete_id: 0,
    athlete_name: '',
    team_id: 0,
    team_name: '',
    season_id: 0,
    season_name: '',
    club_id: 0,
    club_name: '',
    dorsal: '',
    position: '',
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: '',
    current: false
}

export interface AthleteMeasurement {
    id: number;
    athlete_id: number;
    measurement_date: string;
    weight: number;
    height: number;
    bmi: number;
    fm: number;
    bm: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthleteMeasurement: AthleteMeasurement = {
    id: 0,
    athlete_id: 0,
    measurement_date: '',
    weight:0,
    height:0,
    bmi: 0,
    fm: 0,
    bm: 0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface AthleteRanking {
    id: number;
    athlete_id: number;
    ranking_date: string;
    points: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthleteRanking: AthleteRanking = {
    id: 0,
    athlete_id: 0,
    ranking_date: '',
    points:0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

// KPI Definition interface - for managing KPI configurations
export interface KpiDefinition {
    id: number; // Local ID for UI management (not stored in backend)
    kpi_name: string;
    display_name: string;
    description: string;
    unit: string;
    data_type: 'decimal' | 'time'; // Type of data: decimal (2 decimals) or time (hh:mm:ss.ms)
    display_format: string; // Auto-set based on data_type: "0.00" for decimal, "hh:mm:ss.ms" for time
    weight: number;
    is_active: boolean;
    created_by?: number;
    created_at?: string;
    changed_by?: number;
    changed_at?: string;
}

export const emptyKpiDefinition: KpiDefinition = {
    id: 0,
    kpi_name: '',
    display_name: '',
    description: '',
    unit: '',
    data_type: 'decimal',
    display_format: '0.00',
    weight: 0,
    is_active: true,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

// Athlete Performance interface - updated for dynamic KPIs
export interface AthletePerformance {
    athlete_id: number;
    performance_timestamp: string;
    performance_date: string;
    kpis: Record<string, number>; // Dynamic KPIs: { speed: 15.5, power: 85.2, ... }
    created_by?: number;
    created_at: string;
    changed_by?: number;
    changed_at: string;
}

export const emptyAthletePerformance: AthletePerformance = {
    athlete_id: 0,
    performance_timestamp: '',
    performance_date: '',
    kpis: {},
    created_at: '',
    changed_at: ''
}

export interface Athlete {
    id: number;
    user_id: number;
    name: string;
    email: string;
    first_name: string;
    last_name: string;
    birthdate: string;
    phone: string;
    document_id: string;
    description: string;
    avatar: Media[];
    birth_city: string;
    birth_region: string;
    birth_country: string;
    city: string;
    region: string;
    country: string;
    address: string;
    sex: string;
    registered_in: AthleteTeamSeason[];
    measurement: AthleteMeasurement[];
    ranking: AthleteRanking[];
    performance: AthletePerformance[];
    teams: AthleteTeam[];
    status: number;
    garmin_last_refresh: string;
    garmin_access_token: string;
    garmin_refresh_token: string;
    garmin_expires_in: string;
    garmin_scope: string;
    garmin_jti: string;
    garmin_refresh_token_expires_in: string;
    garmin_user_id: string;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthlete: Athlete = {
    id: 0,
    user_id: 0,
    name: '',
    email: '',
    first_name: '',
    last_name: '',
    birthdate: '',
    phone: '',
    document_id: '',
    description: '',
    avatar: [],
    birth_city: '',
    birth_region: '',
    birth_country: '',
    city: '',
    region: '',
    country: '',
    address: '',
    sex: '',
    registered_in: [],
    measurement: [],
    ranking: [],
    performance: [],
    teams: [],
    status: 0,
    garmin_last_refresh: '',
    garmin_access_token: '',
    garmin_refresh_token: '',
    garmin_expires_in: '',
    garmin_scope: '',
    garmin_jti: '',
    garmin_refresh_token_expires_in: '',
    garmin_user_id: '',
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}
